/**
 * QRMaps Design System - Transition Tokens
 *
 * Animation and transition timing
 * Based on values found in MainMap.js (0.2s ease, 0.3s ease)
 */

export const transitions = {
  // Duration
  duration: {
    instant: '0ms',
    fast: '150ms',
    normal: '200ms',
    slow: '300ms',
    slower: '500ms',
    slowest: '1000ms',
  },

  // Easing functions
  easing: {
    linear: 'linear',
    ease: 'ease',
    easeIn: 'ease-in',
    easeOut: 'ease-out',
    easeInOut: 'ease-in-out',
    // Custom cubic-bezier curves
    smooth: 'cubic-bezier(0.4, 0, 0.2, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },

  // Complete transition strings (used in MainMap.js)
  fast: 'all 150ms ease',
  normal: 'all 200ms ease',   // Current: 'all 0.2s ease'
  slow: 'all 300ms ease',     // Current: 'all 0.3s ease'

  // Property-specific transitions
  opacity: 'opacity 200ms ease',
  transform: 'transform 200ms ease',
  color: 'color 200ms ease',
  background: 'background-color 200ms ease',
  border: 'border-color 200ms ease',
  shadow: 'box-shadow 200ms ease',
  all: 'all 200ms ease',
};